import {
  Button,
  IconButton,
  ListItemButton,
  ListItemButtonProps,
  ListItemSecondaryAction,
  ListItemText,
  Skeleton
} from '@mui/material'
import { Asset } from '../types'
import { useTranslation } from 'react-i18next'
import AssetLiftEditButton from './AssetLiftEditButton'

export interface AssetLiftListItemButtonProps extends Omit<ListItemButtonProps, 'children'> {
  asset: Asset
  editable?: boolean
  afterUpdate?: (asset: Asset) => void
}

export default function AssetLiftListItemButton({
  asset,
  editable = false,
  afterUpdate,
  ...props
}: AssetLiftListItemButtonProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('asset')

  return (
    <ListItemButton {...props}>
      <ListItemText
        primary={
          asset.lift ? (
            asset.lift.name
          ) : asset.liftId === null ? (
            t('noLift')
          ) : (
            <Skeleton variant="text" width={100} height={20} />
          )
        }
        primaryTypographyProps={{
          color: asset.liftId === null ? 'text.disabled' : 'inherit'
        }}
        secondary={t('lift')}
      />

      {editable && (
        <ListItemSecondaryAction>
          <AssetLiftEditButton
            asset={asset}
            component={asset.liftId === null ? Button : IconButton}
            variant="outlined"
            afterUpdate={afterUpdate}
          />
        </ListItemSecondaryAction>
      )}
    </ListItemButton>
  )
}
